import styled, { css } from 'styled-components';

export const Text = styled.p<{ withMargin?: boolean }>`
  ${(props) =>
    !props.withMargin &&
    css`
      margin: 0;
    `}
`;
